<template>
    <div class="topic-container" ref="container">
        <div class="topic-column-1 center">
            <div class="topic-group">
                <slot name="column1"></slot>
            </div>
        </div>
        <div class="topic-column-2 center">
            <div class="topic-group" ref="group">
                <slot name="column2"></slot>
            </div>
        </div>

        <slot name="animations"></slot>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState(['layout', 'scene']),

        technology() {
            return this.scene === 'technology'
        },

        horizontal() {
            return this.layout === 'horizontal'
        }
    },

    mounted() {
        this.shirnkGroupIfRequired()
        // add listener for future changes
        window.addEventListener('resize', this.resizeHandler)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler)
    },

    methods: {
        resizeHandler() {
            clearTimeout(this.timerId)
            this.timerId = setTimeout(this.shirnkGroupIfRequired, 300)
        },

        shirnkGroupIfRequired() {
            const { container, group } = this.$refs
            group.style.transform = null

            const containerRect = container.getBoundingClientRect()
            const groupRect = group.getBoundingClientRect()

            if (groupRect.height > containerRect.height) {
                let groupHeight = groupRect.height
                let containerHeight = containerRect.height

                let scaleValue = containerHeight / groupHeight
                group.style.transform = `scale(${scaleValue})`
            }
        }
    }
}
</script>


<style lang="stylus" scoped>
.topic-container {
    width: 100%;
    height: 100%;
}

.topic-column-1 {
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    left: 0;
}

.topic-column-2 {
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    right: 0;
}

.center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.topic-group {
    width: 100%;
}
</style>


<style>
.topic-group .topic:last-of-type {
    margin-bottom: 0 !important;
}
</style>

